import { HttpBackend } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CfgService } from "../../../../cfg/cfg.service";
import { ServerAddressesCfgService } from "src/app/util/serverAddressesCfg.service";

export class WorkersAppealCfg {
  public summaryEndpointPattern: string;
  public detailEndpointPattern: string;
}

export class WorkersAppealKpiCfg {
  public workersAppeal: WorkersAppealCfg;
  public urlAppeal: string;
}

@Injectable()
export class WorkersAppealKpiCfgService extends CfgService<WorkersAppealKpiCfg> {
  json: any = {
    workersAppeal: {
      summaryEndpointPattern: "%{DashboardApiUrl}/workers/{0}/appeal",
      detailEndpointPattern: "%{DashboardApiUrl}/workers/{0}/appeal/detail"
    },
    urlAppeal: "%{OrdersFrontUrl}/orders/"
  }

  constructor(httpBackend: HttpBackend, private serverAddressesCfgService: ServerAddressesCfgService) {
    super(httpBackend);
  }

  protected getCfgFile(): string {
    return `/cfg/kpi/workersAppealKpi.cfg.json`;
  }

  /**
  * Carga las url en el json
  */
  loadDataUrl() {
    this.replacePlaceholders(this.json, this.serverAddressesCfgService.getData());
  }
}
